import { IconButton, Stack, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import DropdownSelection from './DropdownSelection';
import { North, South } from '@mui/icons-material';


interface SortProps {
    sortDirection: boolean;
    setSortDirection: React.Dispatch<React.SetStateAction<boolean>>;
    sortColumn: string;
    sortValues: { value: string, label: string}[];
    setSortColumn: React.Dispatch<React.SetStateAction<string>>;
}

const SortComponent: React.FC<SortProps> = ({
    sortValues,
    sortDirection,
    setSortDirection,
    sortColumn,
    setSortColumn
}) => {
    return (
        <Stack direction="row" spacing={1}>
        <Tooltip title="Sort">
            <DropdownSelection
                dropDownLabel='Sort'
                showHeader={false}
                currentValue={sortColumn}
                sxObject={{width: 200, height: 40, display: 'flex', pl: 3, verticalAlign: 'middle', '&::before, &::after': { display: 'none' }, '& .MuiSelect-select': { p: 0 } }}
                selectionValues={sortValues}
                variant='outlined'
                handleOnChange={(e) => setSortColumn(e.target.value)}
            />
        </Tooltip>
        <Tooltip title={`Sort Direction - ${sortDirection ? 'asc' : 'desc'}`}>
            <IconButton onClick={() => setSortDirection(!sortDirection)}>{sortDirection ? <North /> : <South />}</IconButton>
        </Tooltip>
    </Stack>
    )
}

export default SortComponent;